import { fieldsConfig } from './configFields';

const orderSummaryOptions = [
  {
    property: 'nametag',
    label: 'Nametag'
  },
  {
    property: 'email',
    label: 'Email'
  },
  {
    property: 'phone',
    label: 'Phone'
  },
  {
    property: 'address',
    label: 'Address'
  },
  {
    property: 'volunteer',
    label: 'Volunteering',
    mapping: fieldsConfig['volunteer'].options
  },
  {
    property: 'hospitality',
    label: 'Hospitality (limited availability)',
    // mapping: fieldsConfig['hospitality'].options
  },
  {
    property: 'scholarship',
    label: 'Scholarships (limited availability)',
    // mapping: fieldsConfig['scholarship'].options
  },
  {
    property: 'comments',
    label: 'Comments'
  }
];

export default { orderSummaryOptions };